<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20 3C20 2.44772 20.4477 2 21 2C21.5523 2 22 2.44772 22 3V21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21V3ZM18 12L17.996 12.082L17.9798 12.2007L17.9503 12.3121L17.9063 12.4232L17.854 12.5207L17.8037 12.5952L17.7071 12.7071L13.7071 16.7071C13.3166 17.0976 12.6834 17.0976 12.2929 16.7071C11.9324 16.3466 11.9047 15.7794 12.2097 15.3871L12.2929 15.2929L14.585 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H14.585L12.2929 8.70711C11.9324 8.34662 11.9047 7.77939 12.2097 7.3871L12.2929 7.29289C12.6534 6.93241 13.2206 6.90468 13.6129 7.2097L13.7071 7.29289L17.7071 11.2929L17.7485 11.3369L17.8037 11.4047L17.8753 11.5159L17.9063 11.5769L17.9401 11.6583L17.9642 11.734L17.9932 11.8825L18 12Z"
    fill="currentColor"
  />
</svg>
